import * as z from "zod";

const FulfillmentCutoffDayOfWeekParser_ = z.object({
  activeFulfillmentDay: z.boolean(),
  cutoffTime: z.string().nullable(),
});
export const FulfillmentCutoffDayOfWeekParser: z.ZodType<FulfillmentCutoffDayOfWeek> =
  FulfillmentCutoffDayOfWeekParser_;
export interface FulfillmentCutoffDayOfWeek extends z.infer<
  typeof FulfillmentCutoffDayOfWeekParser_
> {}

export const daysOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const;

const FulfillmentCutoffScheduleParser_ = z.object({
  timezone: z.string(),
  [daysOfWeek[0]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[1]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[2]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[3]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[4]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[5]]: FulfillmentCutoffDayOfWeekParser_,
  [daysOfWeek[6]]: FulfillmentCutoffDayOfWeekParser_,
});
export const FulfillmentCutoffScheduleParser: z.ZodType<FulfillmentCutoffSchedule> =
  FulfillmentCutoffScheduleParser_;
export interface FulfillmentCutoffSchedule extends z.infer<
  typeof FulfillmentCutoffScheduleParser_
> {}

export const DefaultFulfillmentCutoffSchedule: FulfillmentCutoffSchedule = {
  timezone: "America/New_York",
  sunday: { activeFulfillmentDay: false, cutoffTime: null },
  monday: { activeFulfillmentDay: true, cutoffTime: "14:00" },
  tuesday: { activeFulfillmentDay: true, cutoffTime: "14:00" },
  wednesday: { activeFulfillmentDay: true, cutoffTime: "14:00" },
  thursday: { activeFulfillmentDay: true, cutoffTime: "14:00" },
  friday: { activeFulfillmentDay: true, cutoffTime: "14:00" },
  saturday: { activeFulfillmentDay: false, cutoffTime: null },
};
